import React from 'react';
import { AppConfigProvider } from './AppConfigContext';
import { AuthProvider } from './AuthContext';
import { QRProvider } from './QRContext';

const GlobalProvider = ({ children }) => {
  return (
    <AppConfigProvider>
      <AuthProvider>
        <QRProvider>{children}</QRProvider>
      </AuthProvider>
    </AppConfigProvider>
  );
};

export default GlobalProvider;
